import { useTranslations } from '@/contexts/translation/useTranslations';
import AuthenticationData from '@/domains/authentication/type.ts';
import { QUERY_KEYS } from '@/domains/queryKeys.ts';
import { useQuery } from '@tanstack/react-query';
import { client } from '@/domains/client.ts';

const fetchLogin = async () => {
  const { data } = await client.get<Promise<AuthenticationData>>(
    window.react.urls.getAuthentication,
    {
      headers: {
        // Backend requires this header
        internal: 1,
      },
    },
  );

  return data;
};

const useGetAuthentication = () => {
  const { addTranslations } = useTranslations();

  return useQuery({
    queryKey: QUERY_KEYS.AUTHENTICATION,
    queryFn: async () => {
      const data = await fetchLogin();
      addTranslations('auth', data.translations);
      return data;
    },
    staleTime: Infinity,
  });
};

export default useGetAuthentication;
